import { INavigationItem } from './types';
import RouteNavigation from '../constants/RouteNavigation';

export const navigationProcess: INavigationItem = {
  id: '1',
  keyTranslate: 'process',
  allowAnonymous: true,
  icon: 'description',
  url: RouteNavigation.Process,
};